enum MileageDictionaryListingViewMode {
  ADMIN = "ADMIN",
  CARGO = "CARGO",
}

export default MileageDictionaryListingViewMode;
